import { render, staticRenderFns } from "./CountdownTime.vue?vue&type=template&id=2c5cabee&scoped=true&"
import script from "./CountdownTime.vue?vue&type=script&lang=js&"
export * from "./CountdownTime.vue?vue&type=script&lang=js&"
import style0 from "./CountdownTime.vue?vue&type=style&index=0&id=2c5cabee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cabee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
